import { Outlet } from "react-router-dom";
import NavBar from "./NavBar";
import { useAuthInfo } from "@sharpana/auth/authHooks";
import { css } from "@emotion/css";
import OnboardingRedirect from "./pages/Onboarding/OnboardingRedirect";
import ConnectionErrorModal from "./components/ConnectionErrorModal";

export default function Root() {
  const { user, isAuthenticated } = useAuthInfo();

  return (
    <>
      <NavBar />
      <ConnectionErrorModal />
      <main className="flex-shrink-0">
        {!isAuthenticated || (isAuthenticated && user.has_access) ? (
          <div>
            {/* <OnboardingRedirect> */}
            <Outlet />
            {/* </OnboardingRedirect> */}
          </div>
        ) : (
          <div
            className={css`
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
            `}
          >
            <div
              className={css`
                background-color: #2c2c2c;
                border-radius: 8px;
                padding: 24px;
                max-width: 400px;
                text-align: center;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              `}
            >
              <p
                className={css`
                  color: #e0e0e0;
                  font-size: 16px;
                  margin: 0;
                `}
              >
                Sharpana is currently in closed beta/alpha 🔒
                <br />
                You have been added to the waitlist ✅<br />
                Contact the team to expedite your access.
              </p>
            </div>
          </div>
        )}
      </main>
    </>
  );
}
